import React, { useState } from "react"
import { FiLoader } from "react-icons/fi"

export default function Button({
  onClick,
  href,
  children,
  style,
  id,
  className,
  variant = "default",
  Icon,
  disabled = false,
  forceLoading = false,
  faq,
}) {
  const [loading, setLoading] = useState(false)
  const iconStyles = {
    default: "text-lg stroke-2 mr-2 -ml-1",
    secondary: "text-lg stroke-2 mr-2 -ml-1",
    small: "stroke-2 mr-2",
    icon: "text-lg stroke-2",
    "icon-white": "text-lg stroke-2",
    arrow: "stroke-2 m-2 text-red hover:translate-x-3.5",
  }
  const styles = {
    default: `text-base py-1 px-5 bg-yellow rounded-3xl hover:bg-yellow-dark text-black leading-6 lg:leading-10`,
    default2: `text-base py-1 px-2 lg:px-5 bg-greys rounded-lg text-black mt-4 mb-1 lg:leading-6`,
    miniCard: `text-xs py-1 px-2 lg:px-5 bg-yellow rounded-3xl hover:bg-yellow-dark text-black mt-4 mb-1 leading-4 lg:leading-6`,
    secondary: `text-base py-1 lg:py-2 px-6 bg-white border-color-yellow text-yellow hover:text-yellow-dark mt-2`,
    small: `text-sm font-normal py-1 px-3 bg-yellow hover:bg-yellow-dark text-black rounded-xl`,
    icon: `h-8 w-8 py-1 px-1 box-content bg-blue-dark text-black hover:opacity-75 rounded-full mt-2`,
    "icon-white": `h-8 w-8 py-1 px-1 box-content bg-white text-blue-dark hover:opacity-75 rounded-full mt-2`,
    arrow: "text-sm font-normal shadow-none hover:shadow-none",
    footer: "shadow-none h-8 w-8 mt-2 rounded-full overflow-hidden",
  }

  return (
    <a
      href={href}
      target={href && href.match("http") ? "_blank" : ""}
      rel={href && href.match("http") ? "noreferrer noopener" : ""}
      className={faq ? "w-full" : "my-2"}
    >
      <button
        onClick={async () => {
          if (disabled) return
          setLoading(true)
          try {
            await onClick()
          } catch (error) {
            setLoading(false)
          }
          setLoading(false)
        }}
        disabled={disabled || loading || forceLoading}
        style={style}
        className={`relative flex justify-center items-center align-middle focus:outline-none select-none flex-shrink-0 transition-all duration-200 shadow hover:shadow-md ${
          styles[variant]
        } ${className} ${disabled && "bg-gray-200 hover:bg-gray-200"}`}
      >
        {children}
        {Icon && <Icon className={`${iconStyles[variant]}`} />}
        {(loading || forceLoading) && (
          <div className={`absolute w-full h-full p-1 bg-gray-200`}>
            <FiLoader className="stroke-1 rotating box-border w-full h-full" />
          </div>
        )}
      </button>
    </a>
  )
}
